import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, IconName, DropdownItem } from '@optimus-web/core';
import { navigateInModal as navigateInModalAction } from '../../../app/actions/common';

interface Props {
    icon?: IconName;
    onClick?: $TSFixMeFunction;
    url?: string;
    text?: React.ReactNode;
    navigateInModal?: $TSFixMeFunction;
}

class LinkActionMenuItem extends Component<Props> {
    handleOnClick = () => {
        const { onClick, navigateInModal, url } = this.props;
        if (onClick) {
            onClick();
        } else {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            navigateInModal(url);
        }
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'onAfterClick' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { icon, text, onAfterClick, dataTestId } = this.props;
        return (
            <DropdownItem
                leftDetail={icon && <Icon value={icon} />}
                label={text}
                onClick={this.handleOnClick}
                onAfterClick={onAfterClick}
                data-test-id={dataTestId}
                role="menuitem"
            />
        );
    }
}

export default connect(undefined, {
    navigateInModal: navigateInModalAction,
})(LinkActionMenuItem);
